/*
 *@Author: 史泽
 *@Date: 2022-01-17 09:59:40
 *@Description: 渠道管理【公司简介->左半部分】
*/
<template>
  <div class="CompanyprofileLeft">
    <img src="../../../../../../../assets/channel/login/loginCente.png" alt="">
    <div class="CommpanyproText">
      关于归创通桥
    </div>
    <div class="line"></div>
    <div class="text">
      <p>
        我们是中国外周和神经血管植介入医疗设备市场的领先者之一
        。作为一家全面综合性的医疗器械公司，
        我们拥有强大的研发和制造能力、专业的技术
        平台以及成熟的商业化能力。在优秀的管理团
        队带领下，我们持续为中国和海外的医生和患
        者提供人性化的医疗服务和先进的整体解决方案。
      </p>
      <p>
        我们是综合解决方案提供者，提供外周和神经
        血管植介入医疗设备最全面的产品方案。自2012年成立以来，
        我们系统地、有计划地开发了45种优质产品,充分的覆盖了迅
        速发展的神经和外周血管疾病市场。
      </p>
      <p>
        在中国，我们是唯一一家获得CE批准,并在欧
        洲销售外周和神经血管植介入产品的国内医疗器械公司,包括
        外周金属裸支架、药物洗脱支架(DES) 、PTA球囊、药物球囊
        (DCB)和高压PTA球囊，以及取栓支架。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.CompanyprofileLeft {
//   border: 1px solid red;
  width: 500px;
  height: 100%;
  position: relative;
    user-select: none;

  img {
    transform: rotate(180deg);
    position: absolute;
    left: 20px;
  }

  .CommpanyproText {
    width: 120px;
    height: 28px;
    font-size: 20px;
    font-weight: bold;
    color: #00266d;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .line {
    width: 240px;
    height: 1px;
    background-color: #ebedf0;
    margin-bottom: 20px;
  }
  .text {
    font-size: 14px;
    color: #424e66;
  }
  p{
      margin-top: 20px;
  }
}
</style>